import { Box, FsAlert, FsTypography } from '@aviatrix/flights';
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';



export type AlertTypesProps = "error" | "success" | "info" | "warning";

var timer:any = null;
const timeout = 5;// seconds

type AlertProps = {
  message?:string,
  severity?:AlertTypesProps | null

}

declare global {
  interface Window {
    fsAlert:(msg: string, type?:string) => void;
  }
}


const AlertContainer: React.FC = ({message='', severity}:AlertProps) => {
  const globalError:string|null = useSelector((state:any)=>state.error)
  
  const [isVisible, setIsVisible] = React.useState<boolean|null>(false);
  const [Message, setMessage] = React.useState(message);
  const [Severity, setSeverity] = React.useState<AlertTypesProps>(severity || "info");



  React.useEffect(() => {
    (window as any).fsAlert = (msg: string, type: AlertTypesProps) => {
      setMessage(msg);
      setIsVisible(true);
      setSeverity(type)
      timer = setTimeout(() => {
        handleClose()
      }, timeout*1000);
    };

    if(globalError){
      setMessage(globalError);
      setIsVisible(true);
      setSeverity('error')
    }
     
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    clearTimeout(timer);
  }; 
  return (
        <>
        {isVisible===true && 
        <Box sx={{
            position:'absolute',
            width:'100%',
            zIndex:100
        }}>
            <Box p={'4px'} >
              <FsAlert sx={{opacity:1}}
                  severity={Severity}
                  children={<>
                  {<div dangerouslySetInnerHTML={{__html: Message }} ></div>}
                  </>} 
                  onClose={handleClose}
              />
            </Box>
        </Box>
        }
        </>
    )
};

export default AlertContainer;